var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66683 34.5001L34.7502 22.0334C35.0508 21.9053 35.3072 21.6917 35.4874 21.4191C35.6676 21.1465 35.7636 20.8269 35.7636 20.5001C35.7636 20.1733 35.6676 19.8537 35.4874 19.5811C35.3072 19.3085 35.0508 19.0948 34.7502 18.9667L5.66683 6.50008C5.415 6.39024 5.13978 6.34482 4.86601 6.36792C4.59224 6.39102 4.32853 6.48192 4.09866 6.6324C3.86879 6.78289 3.68001 6.98824 3.54934 7.22992C3.41866 7.4716 3.35021 7.74201 3.35016 8.01675L3.3335 15.7001C3.3335 16.5334 3.95016 17.2501 4.7835 17.3501L28.3335 20.5001L4.7835 23.6334C3.95016 23.7501 3.3335 24.4668 3.3335 25.3001L3.35016 32.9834C3.35016 34.1668 4.56683 34.9834 5.66683 34.5001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendicon);
export default __webpack_public_path__ + "static/media/send.icon.6f51e93e8942902de38baa1dfca4dfad.svg";
export { ForwardRef as ReactComponent };